// src/services/pagamentosService.js
import Dexie from 'dexie';
import { liveQuery } from 'dexie';
import http from "@/http-common";
const db = new Dexie('reportsDB');

db.version(1).stores({
  payments: 'id, partyId, organizationId, data',
  lastUpdate: 'partyId, organizationId, timestamp'
});


const paymentService = {
  getPayments(orgId, partyId) {
    return liveQuery(async () => {
      try {
        let { payments, lastUpdate } = await this.getPaymentsFromCache(orgId, partyId);
        return { payments, lastUpdate };
      } catch (error) {
        console.error('Erro ao carregar pagamentos:', error);
        throw error;
      }
    });
  },

  async getPaymentsFromCache(orgId, partyId) {
    try {
      const payments = await db.payments
        .where('partyId')
        .equals(String(partyId))
        .toArray();

      const lastUpdate = await db.lastUpdate.get({ partyId });

      return { payments, lastUpdate: lastUpdate?.timestamp || null };
    } catch (error) {
      console.error('Erro ao buscar pagamentos do cache:', error);
      throw error;
    }
  },

  async updatePayments(orgId, partyId) {
    try {
      const { data } = await http.get(`/admin/organization/${orgId}/party/${partyId}/reports/payments`);
      const payments = data.payments;

      const idCachedPayments = new Set(await db.payments.where('partyId').equals(partyId).primaryKeys());


      const paymentsToSave = payments.map(payment => {
        idCachedPayments.delete(payment.id);
        return {
          ...payment,
          organizationId: orgId,
          partyId: partyId,
        }
      });

      await db.payments.bulkDelete(Array.from(idCachedPayments));
      await db.payments.bulkPut(paymentsToSave);
      await db.lastUpdate.put({
        partyId: partyId,
        organizationId: orgId,
        timestamp: new Date()
      }, partyId);

      this.deleteOldCache();

      return paymentsToSave;
    } catch (error) {
      console.error('Erro ao buscar pagamentos da API:', error);
      throw error;
    }
  },

  async deleteOldCache() {
    // get lastUpdate with timestamp older than 14 days
    const lastUpdate = await db.lastUpdate.toArray();
    const oldLastUpdate = lastUpdate.filter(update => update.timestamp < Date.now() - 14 * 24 * 60 * 60 * 1000);
    await db.lastUpdate.bulkDelete(oldLastUpdate);
    await db.payments.bulkDelete(oldLastUpdate.map(oldLastUpdate => oldLastUpdate.partyId));
  },

  async clearCacheParty(partyId) {
    try {
      await db.payments
        .where('partyId')
        .equals(String(partyId))
        .delete();
      await db.lastUpdate
        .where('partyId')
        .equals(String(partyId))
        .delete();
    } catch (error) {
      console.error('Erro ao limpar o cache da festa:', error);
      throw error;
    }
  },

};

export default paymentService;
